/** Auditoria (17 §3.5): só o admin vê (RLS). */
import { Datagrid, DateField, FunctionField, List, ReferenceField, SelectInput, TextField } from "react-admin";

const tabelas = ["usuario", "papel", "permissao", "parametro_preco_padrao", "aliquota_icms", "parametro_fiscal", "regra_preco"].map(
  (t) => ({ id: t, name: t }),
);
const operacoes = [
  { id: "insert", name: "Inclusão" },
  { id: "update", name: "Alteração" },
  { id: "delete", name: "Exclusão" },
];

const filtros = [
  <SelectInput key="tabela" source="tabela" choices={tabelas} alwaysOn />,
  <SelectInput key="operacao" source="operacao" choices={operacoes} />,
];

function json(valor: unknown): string {
  if (valor === null || valor === undefined) return "—";
  const texto = typeof valor === "string" ? valor : JSON.stringify(valor);
  return texto.length > 120 ? `${texto.slice(0, 117)}…` : texto;
}

export function AuditoriaLista() {
  return (
    <List title="Auditoria" filters={filtros} sort={{ field: "data", order: "DESC" }} perPage={50} actions={false}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <DateField source="data" showTime locales="pt-BR" />
        <TextField source="tabela" />
        <FunctionField source="operacao" render={(r: { operacao: string }) => operacoes.find((o) => o.id === r.operacao)?.name ?? r.operacao} />
        <TextField source="campo" emptyText="—" />
        <FunctionField source="valor_antigo" render={(r: { valor_antigo: unknown }) => json(r.valor_antigo)} />
        <FunctionField source="valor_novo" render={(r: { valor_novo: unknown }) => json(r.valor_novo)} />
        <ReferenceField source="usuario_id" reference="usuario" link={false} emptyText="sistema">
          <TextField source="nome" />
        </ReferenceField>
      </Datagrid>
    </List>
  );
}
